import React from "react";
import { Loading } from "../../Common/OtherElements/Loading";
import {
  getSectionId,
  getSectionName,
  getSectionLayout,
  isSectionFeatured,
} from "./sectionMappingUtils";

const SectionsPanel = ({
  sections,
  selectedSectionId,
  loading,
  onSelectSection,
}) => {
  if (loading) {
    return (
      <div className="card h-100">
        <div className="card-header">
          <h5 className="mb-0">Homepage Sections</h5>
        </div>
        <div className="card-body">
          <Loading />
        </div>
      </div>
    );
  }

  return (
    <div className="card h-100">
      <div className="card-header">
        <h5 className="mb-0">Homepage Sections</h5>
        <p className="text-muted small mb-0 mt-1">
          Select a section to manage mapped contents
        </p>
      </div>
      <div
        className="card-body p-2"
        style={{ maxHeight: "calc(100vh - 220px)", overflowY: "auto" }}
      >
        {sections.length === 0 ? (
          <p className="text-muted text-center py-4 mb-0">
            No content sections found. Create sections first.
          </p>
        ) : (
          <div className="d-flex flex-column gap-2">
            {sections.map((section) => {
              const sectionId = getSectionId(section);
              const isActive =
                String(selectedSectionId) === String(sectionId);

              return (
                <button
                  key={sectionId}
                  type="button"
                  className={`btn text-start p-3 border rounded ${
                    isActive
                      ? "border-primary bg-light shadow-sm"
                      : "border-light bg-light"
                  }`}
                  style={isActive ? { borderWidth: 2 } : undefined}
                  onClick={() => onSelectSection(section)}
                >
                  <div className="fw-semibold">{getSectionName(section)}</div>
                  <div className="mt-2 d-flex flex-wrap gap-1">
                    <span className="badge badge-soft-info">
                      {getSectionLayout(section)}
                    </span>
                    {isSectionFeatured(section) ? (
                      <span className="badge badge-soft-warning">
                        Featured
                      </span>
                    ) : null}
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default SectionsPanel;
